import { PropsWithChildren } from "react";

import { cn } from "@/lib/cn";
import { Row } from "@tanstack/react-table";

import { DatatableRowData } from "../datatable-types";

interface DatatableCellTitleProps<TData extends DatatableRowData> extends PropsWithChildren {
  row: Row<TData>;
  className?: string;
}

export const DatatableCellTitle = <TData extends DatatableRowData>({
  children,
  className,
}: DatatableCellTitleProps<TData>) => {
  return (
    <div className={cn("flex h-full min-w-20 max-w-full flex-1 items-center overflow-hidden", className)}>
      {children}
    </div>
  );
};
